import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import ModalCandidato from "../components/ModalCandidato";
import { MyContext } from "../components/Context.js";
import { Helmet } from "react-helmet";

const Candidato = () => {
  const context = useContext(MyContext);

  const [candidato, setCandidato] = useState(null);
  const { slug } = useParams();
  useEffect(() => {
    if (slug && context.candidatos) {
      const item = context.candidatos.find((f) => f.slug === slug);
      setCandidato(item);
    }
  }, [slug, context.candidatos]);
  return (
    <div>
      <div className="container pl-5">
        <a className="btn btn-primary ml-5" href="https://fundacionmohme.org/especiales/vigilancia-electoral-2022/">
          Ver todos los candidatos con investigaciones
        </a>
        {candidato && (
          <Helmet>
            <meta charSet="utf-8" />
            <title>{candidato.candidato} - Vigilancia Electoral 2022</title>
            <link
              rel="canonical"
              href={
                "https://fundacionmohme.org/especiales/vigilancia-electoral-2022/" +
                candidato.slug +
                "/"
              }
            />
          </Helmet>
        )}
      </div>
      {candidato && (
        <ModalCandidato currentCandidato={candidato} fullPage={true} />
      )}
    </div>
  );
};

export default Candidato;
